import { createApp } from 'vue';
import monitor from '@kk/monitor';
import App from '@/App.vue';
import router from '@/router';
import {store, key} from '@/store';
import types from '@/store/types';
import { globalData, globalDataKey } from '@/global';
import { blackListTeam } from '@/utils';

/**
 * 页面初始化
 */
async function init () {
  if (globalData.isKuaikan) {
    try {
      const { sys: deviceInfo, user } =
        await window.getBaseInfoPromise;
      const deviceId: string = deviceInfo.device_id;
      Object.assign(request.defaults, {
        headers: {
          'X-Device': deviceId
        }
      }); 
      let userId = 0;
      // 如果用户已登录
      if (Number(user.status) === 1) {
        store.commit(types.LOGIN, user);
        userId = user.uid;
      }
      // 接入monitor，distinctId可省略
      monitor.init({
        distinctId: userId || deviceId,
        projectName: '示例项目',
        env: process.env.VUE_APP_HOST_ENV
      });
      kksa.identify(`${userId || deviceId}`);
      if (deviceInfo?.vertical_screen?.top > 20) {
        document.body.classList.add('full');
      }
    } catch (error) {}
  }
  const vue = createApp(App);
  vue.provide(globalDataKey, globalData).use(store, key).use(router).mount('#app');
  blackListTeam();
}

init();
